"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertyList = exports.usePropertyList = exports.usePropertyListStatic = void 0;
const react_1 = require("react");
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const standard_1 = require("react-hook-schema/standard");
const getResourceKey = ({ resourcePath, titleKey, query, }) => {
    return (0, fast_json_stable_stringify_1.default)([resourcePath, titleKey, query]);
};
const usePropertyListStatic = (schema) => {
    const propertyList = (0, react_1.useMemo)(() => Array.from(extractProperties(schema)), [schema]);
    return propertyList;
};
exports.usePropertyListStatic = usePropertyListStatic;
const usePropertyList = (schema) => {
    const propertyList = (0, react_1.useMemo)(() => Array.from(extractProperties(schema)), [schema]);
    const resourceRequests = (0, react_1.useMemo)(() => Object.fromEntries((function* () {
        for (const property of propertyList) {
            const schema = property.schema;
            if (schema.schemaType === "externalKey" ||
                schema.schemaType === "multipleExternalKey") {
                yield [
                    getResourceKey(schema),
                    {
                        resourcePath: schema.resourcePath,
                        titleKey: schema.titleKey,
                        query: schema.query,
                    },
                ];
            }
        }
    })()), [propertyList]);
    const resources = (0, standard_1.useMultipleQueryResource)(resourceRequests);
    return (0, react_1.useMemo)(() => {
        const convertedPropertyList = Array.from(propertyList).map((property) => {
            var _a, _b;
            const schema = property.schema;
            if (schema.schemaType === "externalKey" ||
                schema.schemaType === "multipleExternalKey") {
                const resourceKey = getResourceKey(schema);
                if ((_a = resources[resourceKey]) === null || _a === void 0 ? void 0 : _a.list) {
                    return Object.assign(Object.assign({}, property), { schema: Object.assign(Object.assign({}, property.schema), { schemaType: schema.schemaType === "externalKey"
                                ? "selector"
                                : "multipleSelector", options: (_b = resources[resourceKey]) === null || _b === void 0 ? void 0 : _b.list }) });
                }
            }
            return property;
        });
        return convertedPropertyList;
    }, [propertyList, resources]);
};
exports.usePropertyList = usePropertyList;
const getPropertyList = (baseSchema) => __awaiter(void 0, void 0, void 0, function* () {
    const schema = baseSchema;
    const propertyList = Array.from(extractProperties(schema));
    const resourceRequests = Object.fromEntries((function* () {
        for (const property of propertyList) {
            const schema = property.schema;
            if (schema.schemaType === "externalKey" ||
                schema.schemaType === "multipleExternalKey") {
                yield [
                    getResourceKey(schema),
                    {
                        resourcePath: schema.resourcePath,
                        titleKey: schema.titleKey,
                        query: schema.query,
                    },
                ];
            }
        }
    })());
    const resources = yield (0, standard_1.getListFromMultipleQueries)(resourceRequests);
    const convertedPropertyList = Array.from(propertyList).map((property) => {
        var _a, _b;
        const schema = property.schema;
        if (schema.schemaType === "externalKey" ||
            schema.schemaType === "multipleExternalKey") {
            const resourceKey = getResourceKey(schema);
            if ((_a = resources[resourceKey]) === null || _a === void 0 ? void 0 : _a.list) {
                return Object.assign(Object.assign({}, property), { schema: Object.assign(Object.assign({}, property.schema), { schemaType: schema.schemaType === "externalKey"
                            ? "selector"
                            : "multipleSelector", options: (_b = resources[resourceKey]) === null || _b === void 0 ? void 0 : _b.list }) });
            }
        }
        return property;
    });
    return convertedPropertyList;
});
exports.getPropertyList = getPropertyList;
const extractProperties = function* (schema, path = "") {
    for (const property of (schema === null || schema === void 0 ? void 0 : schema.properties) || []) {
        if (!property.propertyName) {
            continue;
        }
        if (property.schema.schemaType !== "object") {
            yield Object.assign(Object.assign({}, property), { propertyName: `${path}${property.propertyName}` });
        }
        else {
            for (const item of extractProperties(property.schema, `${path}${property.propertyName}.`)) {
                yield item;
            }
        }
    }
};
